import { useTranslation } from "react-i18next";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import ServiceFinder from "@/components/ServiceFinder";
import { WhatsAppCTA } from "@/components/WhatsApp";
import { DEFAULT_WA_MESSAGES, WA_LABELS } from "@/config/site";
import { ShieldCheck, Stethoscope, Compass } from "lucide-react";
import { usePageCms } from "@/lib/siteSettings";

export default function ServiceFinderPage() {
  const { t } = useTranslation();
  const cms = usePageCms("finder");
  const reassurance = [
    { Icon: Compass,     title: t("pub.finderPage.r1t"), body: t("pub.finderPage.r1b") },
    { Icon: Stethoscope, title: t("pub.finderPage.r2t"), body: t("pub.finderPage.r2b") },
    { Icon: ShieldCheck, title: t("pub.finderPage.r3t"), body: t("pub.finderPage.r3b") },
  ];
  return (
    <div className="min-h-screen fl-page" style={{ background: "var(--fl-bg)", color: "var(--fl-text)" }}>
      <PublicHeader />

      {/* Hero */}
      {cms.isVisible("hero") && (
      <section className="pt-32 md:pt-40 pb-16 md:pb-20 px-6 bg-[#0A0A0A] fl-noise relative overflow-hidden">
        <div className="max-w-4xl mx-auto text-center relative">
          <div className="fl-label text-[color:var(--fl-orange)] mb-3">{cms.text("hero", "eyebrow", t("pub.finderPage.eyebrow"))}</div>
          <h1 className="fl-heading text-5xl md:text-6xl leading-none">
            {cms.get("hero").heading ? cms.get("hero").heading : (<>{t("pub.finderPage.h1a")} <span className="text-[color:var(--fl-orange)]">{t("pub.finderPage.h1b")}</span> {t("pub.finderPage.h1c")}</>)}
          </h1>
          <p className="mt-5 text-base md:text-lg max-w-2xl mx-auto" style={{ color: "var(--fl-muted)" }}>
            {cms.text("hero", "body", t("pub.finderPage.subtitle"))}
          </p>
        </div>
      </section>
      )}

      {/* Finder quiz */}
      <section className="py-20 md:py-28 px-6 bg-[#121212] border-t border-white/5">
        <div className="max-w-4xl mx-auto">
          <ServiceFinder />
        </div>
      </section>

      {/* Reassurance */}
      {cms.isVisible("reassurance") && (
      <section className="py-20 md:py-28 px-6 bg-[#0A0A0A] border-t border-white/5">
        <div className="max-w-4xl mx-auto grid md:grid-cols-3 gap-4">
          {reassurance.map(({ Icon, title, body }) => (
            <div key={title} className="fl-card p-5 hover:border-[#f47a20]/40 transition-colors">
              <Icon size={20} className="text-[color:var(--fl-orange)]" />
              <div className="fl-heading text-base mt-3">{title}</div>
              <div className="text-xs mt-1" style={{ color: "var(--fl-muted)" }}>{body}</div>
            </div>
          ))}
        </div>
      </section>
      )}

      {/* WhatsApp CTA */}
      {cms.isVisible("waCta") && (
      <section className="py-24 md:py-32 px-6 bg-gradient-to-b from-[#1A1A1A] via-[#170f0d] to-[#0A0A0A] border-t border-white/5">
        <div className="max-w-4xl mx-auto text-center">
          <WhatsAppCTA message={DEFAULT_WA_MESSAGES.finder} testid="sf-page-wa" size="lg">
            {t("pub.wa.finder")}
          </WhatsAppCTA>
        </div>
      </section>
      )}

      <PublicFooter />
    </div>
  );
}
